import { useGetPublicSettings } from '../api/generated/arrayscapeGamingDashboardAPI';

export { type PublicSettings } from '../api/generated/model';

/**
 * React Query hook for fetching public settings (unauthenticated).
 * Used primarily for displaying company name in the header.
 *
 * Configuration:
 * - Cached for 5 minutes since settings rarely change
 * - Kept in memory for 30 minutes after unmount
 * - Deduplication: Multiple simultaneous calls share the same request
 */
export const usePublicSettings = () => {
  return useGetPublicSettings({
    query: {
      staleTime: 5 * 60 * 1000,  // Data fresh for 5 minutes
      gcTime: 30 * 60 * 1000,    // Keep in cache for 30 minutes
      refetchOnMount: false,     // Don't refetch if data is fresh
      retry: 1,                  // Only retry once on failure
    },
  });
};
